import { IconSvg, iconStar } from '@graphcommerce/next-ui'
import { Box, Chip, ChipProps, Typography } from '@mui/material'
import React from 'react'

export type ProductReviewChipProps = {
  rating?: number
  reviewSectionId?: string
  max?: number
  review_count?: number
} & ChipProps<'button'>

export function ProductReviewChip(props: ProductReviewChipProps) {
  const { rating, reviewSectionId = '', max = 5, review_count = 0, ...chipProps } = props

  if (!rating) return null

  const disabledStar = (
    <IconSvg
      src={iconStar}
      size='large'
      sx={(theme) => ({ stroke: 'none', fill: theme.palette.grey[300] })}
    />
  )

  const star = (
    <IconSvg
      src={iconStar}
      size='large'
      sx={{ stroke: 'none', fill: '#FFDA1C' }}
    />
  )

  const icon = (
    <Box
      sx={[
        {
          width: 'max-content',
          marginRight: 1,
          position: 'relative',
          top: 3
        },
      ]}
    >
      <div>
        {disabledStar}
        {disabledStar}
        {disabledStar}
        {disabledStar}
        {disabledStar}
      </div>
      <Box
        style={{ width: `${rating}%` }}
        sx={{
          position: 'absolute',
          top: 0,
          overflow: 'hidden',
          '& > div': { whiteSpace: 'nowrap' },
        }}
      >
        <div>
          {star}
          {star}
          {star}
          {star}
          {star}
        </div>
      </Box>
    </Box>
  )

  const normalizedRating = Math.round(rating / (10 / max)) / 10

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    const element = document.getElementById(reviewSectionId)
    e.preventDefault()
    if (!element) return

    window.scrollTo({
      top: element.offsetTop - 50,
      left: 0,
      behavior: 'smooth',
    })
  }

  const chip = (
    <Box
      sx={{
        display: 'flex'
      }}>
      <Typography onClick={handleClick} sx={{ cursor: 'pointer' }}>
        {icon}
      </Typography>
      <Typography sx={{ my: 'auto' }}><strong>{normalizedRating}</strong> out of 5 based on <strong>{review_count.toLocaleString()} reviews</strong></Typography>
    </Box>
  )

  if (!reviewSectionId) return chip

  return chip
}
